import React from 'react'
import { useIntl } from 'gatsby-plugin-intl'
import { join, get, includes } from 'lodash/fp'
import { UrlBuilder } from 'masterplan-shared'

import { JobOffer } from '@/interfaces'
import { Caption, FormattedMessage, Link, LinkButton } from '@/components'
import {
  DOM_ID_APPLICATION_FORM,
  URL_APPLICATION,
  URL_DEPARTMENTS,
  URL_DEPARTMENTS_CONTENT,
  URL_DEPARTMENTS_CUSTOMER_SUCCESS,
  URL_DEPARTMENTS_PRODUCT,
  URL_DEPARTMENTS_SALES,
} from '@/constants'

import styles from './JobsDescriptionIntroduction.module.css'

const JobsDescriptionIntroduction: React.FC<{ jobOffer: JobOffer }> = ({
  jobOffer,
}) => {
  const { formatMessage } = useIntl()

  const getDynamicDepartmentLink = () => {
    const link = `${URL_DEPARTMENTS}/${get('department.slug', jobOffer)}`
    const pageExists = includes(link, [
      URL_DEPARTMENTS_PRODUCT,
      URL_DEPARTMENTS_SALES,
      URL_DEPARTMENTS_CUSTOMER_SUCCESS,
      URL_DEPARTMENTS_CONTENT,
    ])

    const departmentText = (
      <span>
        {get('department.name', jobOffer)}
        &nbsp;
        <FormattedMessage id="jobs-description.department" />
      </span>
    )

    return pageExists ? (
      <Link to={link} className={styles.department} variant="pink">
        {departmentText}
      </Link>
    ) : (
      departmentText
    )
  }

  return (
    <div className={styles.staticSection}>
      <Caption variant="h1" size="sm" className={styles.title}>
        {jobOffer.title}
      </Caption>
      <Caption variant="p1" className={styles.details}>
        {getDynamicDepartmentLink()}
        <span className={styles.departmentDot}>&nbsp;&#128900;&nbsp;</span>
        {join(
          ` ${formatMessage({ id: 'jobs-description.or' })} `,
          jobOffer.locations,
        )}
        {jobOffer.types && <span>&nbsp;&#128900;&nbsp;</span>}
        {join(
          ` ${formatMessage({ id: 'jobs-description.or' })} `,
          jobOffer.types,
        )}
      </Caption>
      <LinkButton
        className={styles.button}
        to={UrlBuilder(URL_APPLICATION)
          .addQuery({ offer: jobOffer.slug })
          .joinHash(DOM_ID_APPLICATION_FORM)
          .toString()}
        variant="pink">
        <FormattedMessage id="jobs-description.button" />
      </LinkButton>
    </div>
  )
}

export default JobsDescriptionIntroduction
